import * as ActionTypes from '../ActionTypes';
import MultiLanguageCategoriesApi from '../../api/MultiLanguageCategories';
import { showErrorNotification } from '../Notifications';
import { ERROR_TYPES } from '../../constants/ApiErrorConstants';
import CategoryDetailsRecord from '../../records/edit/CategoryDetailsRecord';
import { selectPrimaryLanguage } from '../../knowledge-base/selectors/knowledgeBaseDetails';
export const categoriesReceived = (response, options) => {
  return {
    type: ActionTypes.FETCH_MULTI_LANGUAGE_CATEGORIES_SUCCESS,
    payload: {
      response,
      options
    }
  };
};
export const categoriesRequesting = () => {
  return {
    type: ActionTypes.FETCH_MULTI_LANGUAGE_CATEGORIES_PENDING
  };
};
export const categoriesRequestFailed = error => {
  return {
    type: ActionTypes.FETCH_MULTI_LANGUAGE_CATEGORIES_ERROR,
    error
  };
};
export const getMultiLanguageCategories = opts => {
  return dispatch => {
    dispatch(categoriesRequesting());
    return MultiLanguageCategoriesApi.getMultiLanguageCategories(opts).then(response => dispatch(categoriesReceived(response, opts)), error => dispatch(categoriesRequestFailed(error)));
  };
};
export const categoryReceived = response => {
  return {
    type: ActionTypes.FETCH_CATEGORY_SUCCESS,
    payload: response
  };
};
export const categoryRequesting = () => {
  return {
    type: ActionTypes.FETCH_CATEGORY_PENDING
  };
};
export const categoryRequestFailed = error => {
  return {
    type: ActionTypes.FETCH_CATEGORY_ERROR,
    error
  };
};
export const getSelectedCategoryDetails = categoryId => {
  return dispatch => {
    dispatch(categoryRequesting());
    return MultiLanguageCategoriesApi.getCategory(categoryId).then(response => dispatch(categoryReceived(response)), error => dispatch(categoryRequestFailed(error)));
  };
};
const categoryCreated = payload => {
  return {
    type: ActionTypes.CREATE_MULTI_LANGUAGE_CATEGORY_SUCCESS,
    payload
  };
};
const categoryCreating = () => {
  return {
    type: ActionTypes.CREATE_MULTI_LANGUAGE_CATEGORY_PENDING
  };
};
const categoryCreateRequestFailed = error => {
  return {
    error,
    type: ActionTypes.CREATE_MULTI_LANGUAGE_CATEGORY_ERROR
  };
};
export const clearCreateMultiLanguageCategoryError = () => {
  return {
    type: ActionTypes.CLEAR_CREATE_MULTI_LANGUAGE_CATEGORY_ERROR
  };
};
export function createMultiLanguageCategory(categoryTranslations, parentCategoryId = 0, knowledgeBaseId, primaryLanguage, homepageSettings) {
  return dispatch => {
    dispatch(categoryCreating());
    return MultiLanguageCategoriesApi.createMultiLanguage(parentCategoryId, categoryTranslations, knowledgeBaseId, primaryLanguage, homepageSettings ? CategoryDetailsRecord.toRequest(homepageSettings) : undefined).then(response => dispatch(categoryCreated(response)), error => {
      const errorCode = error.responseJSON && (error.responseJSON.errorType || error.responseJSON.category);
      const stringKey = error.responseJSON && ERROR_TYPES.CREATE_CATEGORY_ERROR_TYPES.includes(errorCode) ? errorCode : 'default';
      dispatch(categoryCreateRequestFailed(error));
      dispatch(showErrorNotification(`createCategory.${stringKey}`));
    });
  };
}
export function updateCategoryTranslations(category, categoryIdToBeTranslated, knowledgeBaseId) {
  return (dispatch, getState) => {
    dispatch({
      type: ActionTypes.UPDATE_CATEGORY_TRANSLATIONS_PENDING
    });
    const primaryLang = selectPrimaryLanguage(getState());
    return MultiLanguageCategoriesApi.updateCategoryTranslations(category, knowledgeBaseId, primaryLang).then(res => {
      dispatch({
        type: ActionTypes.UPDATE_CATEGORY_TRANSLATIONS_SUCCESS,
        payload: Object.assign({}, res, {
          categoryIdToBeTranslated
        })
      });
    }, error => {
      dispatch({
        type: ActionTypes.UPDATE_CATEGORY_TRANSLATIONS_ERROR,
        error
      });
      throw error;
    });
  };
}